
export function genericFormattedForDropdown(arreglo=[]) {
	if(Array.isArray(arreglo)){
		return addEmptyOption(arreglo.map(renglon => {
		return {
                key: renglon.id,
				value: renglon.id,
				text: renglon.descripcion
			};
		}));	
	}
	
	return [];
	
}


export function genericFormattedForDropdownTexto(arreglo=[]) {
	if(Array.isArray(arreglo)){
		return addEmptyOption(arreglo.map(renglon => {
		return {
                key: renglon.id,
				value: renglon.value,
				text: renglon.texto1
			};
		}));	
	}
	
	return [];
	
}

export function genericFormattedForDropdownDoble(arreglo=[], arreglo2=[]) {
	if(Array.isArray(arreglo)){
		return addEmptyOption(arreglo.map(renglon => {
		return {
                key: renglon.id,
				value: renglon.id,
				text: renglon.descripcion
			};
		}));	
	}
    
    if(Array.isArray(arreglo2)){
		return addEmptyOption(arreglo2.map(renglon => {
		return {
                key: renglon.id,
				value: renglon.id,
				text: renglon.descripcion
			};
		}));	
	}
	
	return [];
	
}

export function genericFormattedForDropdownByNombre(arreglo=[]) {
     
	if(Array.isArray(arreglo)){
		return addEmptyOption(arreglo.map(renglon => {
		return {
                key: renglon.id,
				value: renglon.id,
				text: renglon.nombre
			};
		}));	
	}
	
	return [];
	
}

export function addEmptyOption(arreglo) {

	if (arreglo.length > 0) {
		let vacio = {
            key:'',
			value: '',
			text: '(borrar selección)'
		};
		arreglo.unshift(vacio);

	}
	return arreglo;

}

export function sinEmptyOption(arreglo) {
	return arreglo;

}

export function genericFormattedForGrafica(arreglo=[]) {
	if(Array.isArray(arreglo)){
		return sinEmptyOption(arreglo.map(renglon => {
		return {
				value: renglon.id,
				name: renglon.descripcion
			};
		}));	
	}
	
	return [];
	
}